import * as React from "react"
import { useTranslation } from "react-i18next"
import styled from "styled-components"
import { HorizontalSpacer } from "../../atoms/spacers"
import H3 from "../../atoms/typography/H3"
import H4 from "../../atoms/typography/H4"
import PrimaryButton from "../../atoms/buttons/PrimaryButton"

interface Props {
  onClose: () => void
  onClickDelete: () => void
}

const ContentContainer = styled.div`
  padding: ${(props) => `${props.theme.spacings.large} ${props.theme.spacings.larger}`};
`

const ActionButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const DeleteAccountWarningModal: React.FunctionComponent<Props> = ({ onClose, onClickDelete }) => {
  const { t } = useTranslation()

  return (
    <ContentContainer>
      <H4 textAlign="center">Are you sure you want to delete your account?</H4>
      <HorizontalSpacer spacing={2} />
      <H3 textAlign="center">You will no longer have access to group information, terminals and members.</H3>
      <HorizontalSpacer spacing={3} />
      <ActionButtonContainer>
        <PrimaryButton title="Delete account" onClick={onClickDelete} destructive />
        <PrimaryButton title={t("common.cancel")} onClick={onClose} />
      </ActionButtonContainer>
    </ContentContainer>
  )
}

export default DeleteAccountWarningModal
